<!--
 * @Author: p_fy
 * @Date: 2019-07-18 17:22:46
 * @LastEditors: pfy
 * @LastEditTime: 2019-09-24 18:09:45
 * @Description: 仓库推荐列表，状态：常规推荐、智能推荐。
 -->
<template>
  <div class="transport-news">
    <el-dialog
      :visible.sync="invitationVisible"
      title="仓库推荐"
      width="80%"
      @close="$emit('close', false)"
    >
      <div class="demand-head">
        <div class="slider-list">
          <div :class="{ 'selected': !state}" class="item" @click="toggleState()">常规推荐</div>
          <div :class="{ 'selected': state}" class="item" @click="toggleState()">智能推荐</div>

        </div>
        <!-- 查询表单  -->
        <div v-if="!state && warehousingType == '1'" class="supply-head-form">
          <div class="fileds">
            <el-form ref="form" :model="queryParams" :inline="true">
              <div class="supply-condition">
                <el-form-item label="租单名称:" prop="supplyName">
                  <el-input v-model="queryParams.supplyName" placeholder="请输入" />
                </el-form-item>
                <el-form-item label="货物类型:" prop="storageType">
                  <el-select v-model="queryParams.storageType" placeholder="请选择">
                    <el-option
                      v-for="(item,index) in storageType.storageType"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item label="库房位置:" prop="storageLocation">
                <el-cascader
                  v-model="queryParams.storageLocation"
                  :options="area"
                  :filterable="true"
                  :props="{ expandTrigger: 'hover' ,
                            checkStrictly: true}"
                  style="width: 100%;"
                  @expand-change="expandChange"
                />
              </el-form-item>
                <el-form-item label="可租用面积:" prop="rentableStartArea">
                  <div class="supply-area">
                    <el-row>
                      <el-col :span="11">
                        <el-form-item prop="rentableStartArea">
                          <el-input
                            v-model.number="queryParams.rentableStartArea"
                            placeholder="请输入"
                            @change="startChange"
                          />
                        </el-form-item>
                      </el-col>
                      <el-col :span="2">
                        <span>至</span>
                      </el-col>
                      <el-col :span="11">
                        <el-form-item prop="rentableStopArea">
                          <el-input
                            v-model.number="queryParams.rentableStopArea"
                            placeholder="请输入"
                            @change="endChange"
                          />
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </div>
                </el-form-item>
              </div>
            </el-form>
          </div>
          <div class="buttons">
            <el-button
              size="small"
              style="background-color: #BE2316;border-color: #F56C6C;"
              class="form-item-btn"
              type="primary"
              @click="loadInvitationData"
            >
              <i class="el-icon-search" />查询
            </el-button>
            <el-button
              size="small"
              style="background-color: #BE2316;border-color: #F56C6C;"
              class="form-item-btn"
              type="primary"
              @click="resetForm"
            >
              <i class="el-icon-delete-solid" />
              重置
            </el-button>
          </div>
        </div>
        <div v-if="!state && warehousingType != '1'" class="supply-head-form">
          <div class="fileds">
            <el-form ref="tankform" :model="tankQueryParams" :inline="true">
              <div class="supply-condition">
                <el-form-item label="租单名称:" prop="supplyName">
                  <el-input v-model="tankQueryParams.supplyName" placeholder="请输入" />
                </el-form-item>
                <el-form-item label="货物类型:" prop="storageType">
                  <el-select v-model="tankQueryParams.storageType" placeholder="请选择">
                    <el-option
                      v-for="(item,index) in storageType.storageType"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item label="起租灌数:" prop="leasePotCount">
                  <el-input v-model="tankQueryParams.leasePotCount" placeholder="请输入" />
                </el-form-item>
                <el-form-item label="库房位置:" prop="storageLocation">
                  <el-cascader
                    v-model="tankQueryParams.storageLocation"
                    :options="area"
                    :filterable="true"
                    :props="{ expandTrigger: 'hover' ,
                              checkStrictly: true}"
                    style="width: 100%;"
                    @expand-change="expandChange"
                  />
                </el-form-item>
                <el-form-item style='width:74%' label="罐区容积:" prop="potStartArea">
                  <div class="supply-area">
                    <el-row>
                      <el-col :span="11">
                        <el-form-item prop="potStartArea">
                          <el-input
                            v-model="tankQueryParams.potStartArea"
                            placeholder="请输入"
                            @change="tankstartChange"
                          />
                        </el-form-item>
                      </el-col>
                      <el-col :span="2">
                        <span>至</span>
                      </el-col>
                      <el-col :span="11">
                        <el-form-item prop="potEndArea">
                          <el-input
                            v-model="tankQueryParams.potEndArea"
                            placeholder="请输入"
                            @change="tankendChange"
                          />
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </div>
                </el-form-item>
              </div>
            </el-form>
          </div>
          <div class="buttons">
            <el-button
              size="small"
              style="background-color: #BE2316;border-color: #F56C6C;"
              class="form-item-btn"
              type="primary"
              @click="loadInvitationData"
            >
              <i class="el-icon-search" />查询
            </el-button>
            <el-button
              size="small"
              style="background-color: #BE2316;border-color: #F56C6C;"
              class="form-item-btn"
              type="primary"
              @click="tankResetForm"
            >
              <i class="el-icon-delete-solid" />
              重置
            </el-button>
          </div>
        </div>
        <div v-loading="viewManager.loading" class="invitation-data">
          <div class="invitation-data-header">
            <ul>
              <li>租单名称</li>
              <li>储存类型</li>
              <li>库房位置</li>
              <li v-if="warehousingType == '1' ">可租用面积</li>
              <li v-if="warehousingType == '1' ">期望租金</li>
              <li v-if="warehousingType != '1' ">罐区容积</li>
              <!-- <li v-if="warehousingType != '1' ">起租灌数</li> -->
              <li v-if="warehousingType != '1' ">期望租金</li>
              <li>操作</li>
            </ul>
          </div>
          <div class="invitation-data-body">
            <template v-if="!viewManager.loading && invitationData.length < 1">
              <div class="no-data-info">
                <font>暂无匹配数据</font>
              </div>
            </template>
            <template v-for="(item, index) of invitationData">
              <div :key="index" class="data-item">
                <ul>
                  <el-tooltip class="item" effect="dark" :content="item.supplyName" placement="top">
                    <li :title="item.supplyName">{{ item.supplyName }}</li>
                  </el-tooltip>
                  <el-tooltip
                    v-if="warehousingType == '1' "
                    class="item"
                    effect="dark"
                    :content="item.storageTypeLabel"
                    placement="top"
                  >
                    <li :title="item.storageTypeLabel">{{ item.storageTypeLabel }}</li>
                  </el-tooltip>
                  <el-tooltip
                    v-if="warehousingType != '1' "
                    class="item"
                    effect="dark"
                    :content="item.tankTypeLabel"
                    placement="top"
                  >
                    <li :title="item.tankTypeLabel">{{ item.tankTypeLabel }}</li>
                  </el-tooltip>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="item.storageLocationLabel"
                    placement="top"
                  >
                    <li :title="item.storageLocationLabel">{{ item.storageLocationLabel }}</li>
                  </el-tooltip>
                  <el-tooltip
                    v-if="warehousingType == '1' "
                    class="item"
                    effect="dark"
                    :content="`${item.rentableArea}㎡`"
                    placement="top"
                  >
                    <li :title="item.rentableArea">{{ item.rentableArea }}㎡</li>
                  </el-tooltip>
                  <el-tooltip
                    v-if="warehousingType == '1' "
                    class="item"
                    effect="dark"
                    :content="`${item.expectPrice}m²/天`"
                    placement="top"
                  >
                    <li :title="item.expectPrice">{{ item.expectPrice }}/m²/天</li>
                  </el-tooltip>
                  <el-tooltip
                    v-if="warehousingType != '1' "
                    class="item"
                    effect="dark"
                    :content="`${item.potArea}m³`"
                    placement="top"
                  >
                    <li :title="item.potArea">{{ item.potArea }}m³</li>
                  </el-tooltip>
                  <el-tooltip
                    v-if="warehousingType != '1' "
                    class="item"
                    effect="dark"
                    :content="`${item.expectPrice}m³/天`"
                    placement="top"
                  >
                    <li :title="item.expectPrice">{{ item.expectPrice }}m³/天</li>
                  </el-tooltip>
                  <li>
                    <el-button
                      size="mini"
                      type="text"
                      :style="{color:item.collectionStatus == '1' ? '#be2316' : '#409EFF'}"
                      @click="favorites(item)"
                    >{{ item.collectionStatus == '1' ?'已收藏':'未收藏' }}</el-button>
                    <el-divider direction="vertical" />
                    <el-button
                      v-if="item.publishStatus == '3'"
                      style="color: #be2316 !important;"
                      type="text"
                    >已成交</el-button>
                    <el-button
                      v-else
                      type="text"
                      style="color: #66b1ff !important;"
                      @click="deal(item)"
                    >成交</el-button>
                    <el-divider direction="vertical" />
                    <el-button
                      v-if="item.appointmentStatus == '0' "
                      size="mini"
                      type="text"
                      style="color:#be2316;"
                      @click="order(item)"
                    >预约看仓</el-button>
                    <el-button v-else size="mini" type="text" style="color:#be2316;">已预约</el-button>
                    <el-divider direction="vertical" />
                    <el-button plain size="small" @click="supplyInfo(item)">
                      详情
                      <i :class="{'expand': !item.hidden}" class="el-icon-d-arrow-right" />
                    </el-button>
                  </li>
                </ul>
                <storeSupplyInfo
                  v-if="!item.hidden && warehousingType == '1' "
                  style="position: initial;"
                  :supply="item"
                />
                <tankSupplyInfo
                  v-if="!item.hidden && warehousingType != '1' "
                  style="position: initial;"
                  :supply="item"
                />
              </div>
            </template>
          </div>
          <div class="invitation-data-pagination">
            <el-pagination
              :current-page="invitationPagination.pageNo"
              :total="invitationPagination.total"
              :page-size="invitationPagination.pageSize"
              layout="prev, pager, next, jumper,total, sizes"
              @current-change="invitationChangeCurrent"
              @size-change="invitationChangeSize"
            />
          </div>
        </div>
      </div>
    </el-dialog>
    <order-warehousing
      ref="orderDialog"
      :order-type="warehousingType"
      :order-manager="orderManager.visible"
      :order-data="orderManager.data"
      @close="orderManager.close"
    />
    <store-deal
      ref="dealDialog"
      :deal-type="warehousingType"
      :deal-manager="dealManager.visible"
      :deal-data="dealManager.data"
      :demand-data="invitationForm"
      @close="dealManager.close"
      @closeSuccess="dealManager.closeSuc"
    />
  </div>
</template>
<script>
// 普仓供应详情
import storeSupplyInfo from '../store-supply-list/components/storeSupplyInfo'
// 罐区供应详情
import tankSupplyInfo from '../tank-supply-list/components/tankSupplyInfo'
import orderWarehousing from '../../../cloud/components/orderWarehousing'
import storeDeal from './storeDeal'
import {
  findPageSupply,
  tankfindPageSupply,
  getArea,
  getDict,
  conllection
} from '@/api/personal/store/warehouseSuggest'
import { tableClass } from '@/api/cloud/storage-demand-info/components/StorageDemandItemsParam' // 仓储供给信息、表单参数列表
import { DatabaseUtil } from '@/utils/databaseUtils'
const dataBase = new DatabaseUtil()
const table = tableClass.getTable() // 引用表格参数类(包含查询条件的表单)
export default {
  name: 'InviteWarehousing',
  components: {
    storeSupplyInfo,
    tankSupplyInfo,
    orderWarehousing,
    storeDeal
  },
  props: {
    invitationManager: { type: Boolean, default: () => false },
    invitationForm: { type: Object, default: () => {} },
    warehousingType: { type: String, default: () => '1' }
  },
  data() {
    return {
      invitationVisible: this.invitationManager,
      invitationPagination: table.Page,
      invitationData: [],
      viewManager: {
        loading: true
      },
      area: [],
      orderManager: {
        visible: false,
        data: {},
        close: () => {
          this.loadInvitationData()
          this.orderManager.visible = false
        }
      },
      dealManager: {
        visible: false,
        data: {},
        close: () => {
          this.loadInvitationData()
          this.dealManager.visible = false
        },
        closeSuc: () => {
          this.dealManager.visible = false
          this.$emit('close', false)
        }
      },
      allSelection: false,
      state: false,
      Intelligence: true,
      queryParams: {
        supplyName: null,
        storageType: null,
        rentableStartArea: null,
        rentableStopArea: null,
        storageLocation: null,
        publishStatus: '2',
        warehouseType: null
      },
      tankQueryParams: {
        supplyName: null,
        storageType: null,
        leasePotCount: null,
        potStartArea: null,
        potEndArea: null,
        storageLocation: null,
        publishStatus: '2'
      },
      storageType: {
        storageType: [],
        area: []
      }
    }
  },
  watch: {
    invitationManager() {
      this.invitationVisible = this.invitationManager
      if (this.invitationVisible) {
        this.loadInvitationData()
      }
    },
    'queryParams.rentableStartArea': {
      handler: function(val) {
        var reg = /^0{1}([.]\d{1,2})?$|^[1-9]\d*([.]{1}[0-9]{1,2})?$/
        if (
          !this.isEmpty(val) &&
          this.isEmpty(this.queryParams.rentableStopArea)
        ) {
          this.queryParams.rentableStopArea = 1
        }
        if (!this.isEmpty(val) && (val == 0 || !reg.test(val))) {
          this.queryParams.rentableStartArea = 1
        } else {
          if (
            parseFloat(this.queryParams.rentableStartArea) >
            parseFloat(this.queryParams.rentableStopArea)
          ) {
            this.queryParams.rentableStopArea = this.queryParams.rentableStartArea
          }
        }
      }
    },
    'queryParams.rentableStopArea': {
      handler: function(val) {
        var reg = /^0{1}([.]\d{1,2})?$|^[1-9]\d*([.]{1}[0-9]{1,2})?$/
        if (
          !this.isEmpty(val) &&
          this.isEmpty(this.queryParams.rentableStartArea)
        ) {
          this.queryParams.rentableStartArea = 1
        }
        if (!this.isEmpty(val) && (val == 0 || !reg.test(val))) {
          this.queryParams.rentableStopArea = 1
        }
      }
    },
    'tankQueryParams.potStartArea': {
      handler: function(val) {
        var reg = /^0{1}([.]\d{1,2})?$|^[1-9]\d*([.]{1}[0-9]{1,2})?$/
        if (
          !this.isEmpty(val) &&
          this.isEmpty(this.tankQueryParams.potEndArea)
        ) {
          this.tankQueryParams.potEndArea = 1
        }
        if (!this.isEmpty(val) && (val == 0 || !reg.test(val))) {
          this.tankQueryParams.potStartArea = 1
        } else {
          if (
            parseFloat(this.tankQueryParams.potStartArea) >
            parseFloat(this.tankQueryParams.potEndArea)
          ) {
            this.tankQueryParams.potEndArea = this.tankQueryParams.potStartArea
          }
        }
      }
    },
    'tankQueryParams.potEndArea': {
      handler: function(val) {
        var reg = /^0{1}([.]\d{1,2})?$|^[1-9]\d*([.]{1}[0-9]{1,2})?$/
        if (
          !this.isEmpty(val) &&
          this.isEmpty(this.tankQueryParams.potStartArea)
        ) {
          this.tankQueryParams.potStartArea = 1
          console.log(11111)

        } this.queryParams
        if (!this.isEmpty(val) && (val == 0 || !reg.test(val))) {
          this.tankQueryParams.potEndArea = 1
        }
      }
    },
    'tankQueryParams.leasePotCount': {
      handler: function(val) {
        var reg = /^0{1}([.]\d{1,2})?$|^[1-9]\d*([.]{1}[0-9]{1,2})?$/
        if (val != null && val != '' && (val == 0 || !reg.test(val))) {
          this.tankQueryParams.leasePotCount = 1
        }
      }
    },
    'queryParams.supplyName': {
      handler: function(val) {
        var reg = this.$character(0, 20, 'regular')
        if (!reg.test(this.queryParams.supplyName)) {
          this.queryParams.supplyName = ''
        }
      }
    },
    'tankQueryParams.supplyName': {
      handler: function(val) {
        var reg = this.$character(0, 20, 'regular')
        if (!reg.test(this.tankQueryParams.supplyName)) {
          this.tankQueryParams.supplyName = ''
        }
      }
    }
  },
  created() {
    this.getArea()
    this.getStorageType()
  },
  methods: {
    // 仓库面积范围
    tankstartChange(val) {
      if (
        !this.isEmpty(this.tankQueryParams.potEndArea) &&
        this.isEmpty(this.tankQueryParams.potStartArea)
      ) {
        // this.tankQueryParams.potStartArea = 1
      }
    },
    // 仓库面积范围
    tankendChange(val) {
      if (
        !this.isEmpty(this.tankQueryParams.potStartArea) &&
        this.isEmpty(this.tankQueryParams.potEndArea)
      ) {
        // this.tankQueryParams.potEndArea = 1
      }
      if (
        parseFloat(this.queryParams.potStartArea) >
        parseFloat(this.tankQueryParams.potEndArea)
      ) {
        this.tankQueryParams.potEndArea = this.queryParams.potStartArea
      }
    },
    // 仓库面积范围
    startChange(val) {
      if (
        !this.isEmpty(this.queryParams.rentableStopArea) &&
        this.isEmpty(this.queryParams.rentableStartArea)
      ) {
        // this.queryParams.rentableStartArea = 1
      }
    },
    // 仓库面积范围
    endChange(val) {
      if (
        !this.isEmpty(this.queryParams.rentableStartArea) &&
        this.isEmpty(this.queryParams.rentableStopArea)
      ) {
        // this.queryParams.rentableStopArea = 1
      }
      if (
        parseFloat(this.queryParams.rentableStartArea) >
        parseFloat(this.queryParams.rentableStopArea)
      ) {
        // this.queryParams.rentableStopArea = this.queryParams.rentableStartArea
      }
    },
    // 判断字符是否为空的方法
    isEmpty(obj) {
      if (typeof obj == 'undefined' || obj == null || obj == '') {
        return true
      } else {
        return false
      }
    },
    getLocalStorageUtil(name) {
      return new Promise((resolve, reject) => {
        if (dataBase.localStorageUtil.has(name)) {
          resolve(JSON.parse(dataBase.localStorageUtil.get(name)))
        } else {
          reject(name)
          console.log(name)
        }
      })
    },
    setLocalStorageUtil(name, result) {
      dataBase.localStorageUtil.set(name, JSON.stringify(result))
    },
    // 仓库位置点击事件处理
    expandChange() {
      setTimeout(function() {
        var alist = document.getElementsByClassName('el-radio__original')
        if (alist) {
          for (var idx = 0; idx < alist.length; idx++) {
            var mya = alist[idx]
            mya.style.cssText =
              'width:160px;height:34px;z-index:1;top:-10px;cursor:inherit'
          }
        }
      }, 100)
    },
    // 地址字典
    getArea() {
      this.getLocalStorageUtil('area').then((data) => {
        this.area = data
      }).catch(() => {
        getArea()
          .then(data => {
            this.area = data.result
            this.setLocalStorageUtil('area', data.result)
          })
          .catch(error => {
            console.error(error)
          })
      })
    },
    // 储存类型字典
    getStorageType() {
      this.getLocalStorageUtil('storageType')
        .then(storageType => {
          console.log(storageType)
          if (storageType.length > 0) {
            storageType.forEach(res => {
              this.storageType.storageType.push({
                label: res.label,
                value: res.value
              })
            })
          }
        })
        .catch(() => {
          getDict('storageType')
            .then(res => {
              const storageType = JSON.parse(res.result)
              this.setLocalStorageUtil('storageType', storageType)
              if (storageType.length > 0) {
                storageType.forEach(res => {
                  this.storageType.storageType.push({
                    label: res.label,
                    value: res.value
                  })
                })
              }
            })
            .catch(err => {
              console.error(err)
            })
        })
      return
    },
    // 重置
    resetForm() {
      this.$refs['form'].resetFields()
      this.queryParams.storageLocation = null
      this.loadInvitationData()
    },
    // 罐区重置
    tankResetForm() {
      this.$refs['tankform'].resetFields()
      this.tankQueryParams.storageLocation = null
      this.loadInvitationData()
    },
    // 监听分页
    invitationChangeSize(size) {
      this.invitationPagination.pageSize = size
      this.loadInvitationData()
    },
    // 监听分页
    invitationChangeCurrent(current) {
      this.invitationPagination.pageNo = current
      this.loadInvitationData()
    },
    // 预约看仓
    order(supply) {
      this.orderManager.data = supply

      this.orderManager.visible = true
      // appointment({ supplyId: supply.id, contactMan: supply.linkMan, tel: supply.telephone, demandType: this.warehousingType }).then(res => {
      //   this.orderManager.data = supply
      //   supply.appointmentStatus = '1'
      //   this.orderManager.visible = true
      // }).catch(err => {
      //   console.log(err)
      // })
    },
    // 详情展示
    supplyInfo(supply) {
      if (supply.hidden) {
        this.invitationData.map(res => {
          res.hidden = true
          return res
        })
      }
      supply.hidden = !supply.hidden
    },
    // 列表查询
    loadInvitationData() {
      this.viewManager.loading = true
      if (this.warehousingType == '1') {
        // 普仓查询
        const obj = {}
        // if (this.state) {
        //   obj.warehouseType = this.invitationForm.warehouseType1
        //   obj.storageLocation = this.invitationForm.storageLocation
        // }
     
          const params = Object.assign(   this.invitationPagination,this.queryParams, )
      if (params.storageLocation != null && params.storageLocation.length > 0) {
        params.storageLocation = params.storageLocation.join('#')
      }
        findPageSupply(params)
          .then(res => {
            console.log(res)
            const invit = []
            res.result.rows.forEach(res => {
              if (res != null) {
                res.hidden = true
                res.selection = false
                res.collectionSubmit = false
                invit.push(res)
              }
            })
            this.invitationPagination.total = res.result.total
            this.invitationData = invit
          })
          .catch(err => {
            this.invitationPagination.total = this.invitationData.length
            console.log(err)
          })
          .finally(() => {
            this.viewManager.loading = false
          })
      } else {
        // 罐区查询
        const obj2 = {}
        if (this.state) {
          obj2.storageType = this.invitationForm.storageType
          obj2.storageLocation = this.invitationForm.storageLocation
        }

        
      const params = Object.assign(   this.invitationPagination,this.tankQueryParams, )
      if (params.storageLocation != null && params.storageLocation.length > 0) {
        params.storageLocation = params.storageLocation.join('#')
      }
        // if (
        //   params.storageLocation != null &&
        //   params.storageLocation.length > 0
        // ) {
        //   params.storageLocation = params.storageLocation.join('#')
        // }
        tankfindPageSupply(params)
          .then(res => {
            const invit = []
            res.result.rows.forEach(res => {
              if (res != null) {
                res.hidden = true
                res.selection = false
                res.collectionSubmit = false
                invit.push(res)
              }
            })
            this.invitationPagination.total = res.result.total
            this.invitationData = invit
          })
          .catch(err => {
            this.invitationPagination.total = this.invitationData.length
            console.log(err)
          })
          .finally(() => {
            this.viewManager.loading = false
          })
      }
    },
    // 多选
    invitationSelSummit() {
      const selData = []
      this.invitationData.forEach(res => {
        if (res.selection) {
          selData.push(res.id)
        }
      })
    },
    // 收藏
    favorites(item) {
      // 重复点击
      if (item.collectionSubmit) {
        return false
      }
      item.collectionSubmit = true
      const collStatus = item.collectionStatus == '1' ? '2' : '1'
      // 发起收藏?取消收藏的请求
      conllection({
        id: item.collectionId,
        moduleId: item.id,
        moduleType: this.warehousingType == '1' ? '5' : '6',
        collectionStatus: collStatus
      })
        .then(data => {
          item.collectionStatus = collStatus
          item.collectionId = data.result.id
          this.$message({
            offset: 100,
            message: item.collectionStatus == '1' ? '收藏成功' : '取消收藏成功',
            type: item.collectionStatus == '1' ? 'success' : 'warning'
          })
          item.collectionSubmit = false
        })
        .catch(error => {
          console.error(error)
          item.collectionSubmit = false
        })
    },
    // 成交
    deal(item) {
      this.dealManager.data = item
      this.dealManager.visible = true
    },
    // 查询
    invitationFormSummit() {
      // this.loadInvitationData()
    },
    toggleState() {
      this.state = !this.state
      this.loadInvitationData()
    }
  }
}
</script>

<style scoped lang='scss'>
$main-color: #be2316;
.transport-news {
  margin-bottom: 1rem;
}
/deep/.demand-head {
  padding: 1rem;
  border-style: solid;
  border-width: 0 0 1px 0;
  border-color: #f1f1f1;
  background-color: #ffffff;
  .slider-list {
    display: block;
    margin: 0 0;
    height: 36px;
    overflow: auto;
    white-space: nowrap;
    border-bottom: 1px solid #f1f1f1;
    &::-webkit-scrollbar {
      height: 0px !important;
      width: 0px !important;
    }
    &::-moz-scrollbar {
      height: 0px !important;
      width: 0px !important;
    }
    .item {
      // height: 35px;
      height: calc(100% - 1px);
      display: inline-block;
      width: 100px;
      font-size: 16px;
      font-weight: 600;
      line-height: 35px;
      margin-right: 12px;
      border-bottom: 1px solid rgba(0, 0, 0, 0);
      text-align: center;
      transition: all 1s;
      color: black;
      cursor: pointer;
      &.selected {
        border-bottom: 1px solid $main-color;
        transition: all 1s;
        color: $main-color;
      }
    }
  }
  .supply-head-form {
    padding-top: 1rem;
    display: flex;
    .fileds {
      width: 100%;
      // flex: 0 1 75%;
      /deep/ .el-form-item {
        label:after {
          content: "";
        }
      }
      .supply-condition {
        display: flex;
        flex-wrap: wrap;
        /deep/.el-form-item .el-form-item__content {
          display: flex;
          flex-wrap: wrap;
          width: 217px;
          .supply-area {
            display: inline-flex;
            -webkit-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            padding: 3px 10px;
            -webkit-appearance: none;
            background-color: #fff;
            background-image: none;
            border-radius: 4px;
            border: 1px solid #dcdfe6;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            color: #606266;
            font-size: inherit;
            height: 40px;
            line-height: 40px;
            outline: 0;
            -webkit-transition: border-color 0.2s
              cubic-bezier(0.645, 0.045, 0.355, 1);
            transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
            width: 100%;
            /deep/.el-form-item__content {
              width: auto;
            }
            &:focus {
              border-color: #409eff;
              outline: 0;
            }
            &:hover {
              border-color: #c0c4cc;
            }
            .el-form-item {
              padding-right: 0px;
              width: 100%;
              margin-right: 0 !important;
              /deep/.el-input .el-input__inner {
                border: 0px solid #dcdfe6;
                height: 36px;
                line-height: 36px;
                text-align: center;
              }
            }
          }
        }
        .el-form-item {
          display: flex;
          -webkit-box-pack: end;
          -ms-flex-pack: end;
          justify-content: flex-end;
          padding-right: 22px;
          width: 50%;
          -webkit-box-sizing: border-box;
          box-sizing: border-box;
          margin-right: 0 !important;
        }
      }
    }
    .buttons {
      flex: 0 1 35%;
      display: inherit;
      align-items: center;
      justify-content: center;
    }
  }
}
/deep/.main-wrap {
  margin-top: 1rem;
  .main {
    width: 1200px;
    margin: 0 auto 1rem;
    border: 1px solid rgba(229, 229, 229, 1);
    box-sizing: border-box;
    .el-form-item {
      padding-left: 20px;
      padding-right: 20px;
      .el-tag {
        margin-right: 1rem;
      }
    }
    .el-form {
      .selected-conditions {
        background-color: #f6f6f6;
        .el-form-item__content {
          display: flex;
          flex-wrap: wrap;
          .el-tag {
            margin-top: auto;
            margin-bottom: auto;
          }
        }
        .clear-conditions {
          cursor: pointer;
          color: #999999;
          align-items: flex-end;
          display: block;
          margin-left: auto;
        }
      }
      .capacity-content {
        .el-form-item__content {
          display: flex;
        }
        .el-input {
          margin-right: 1rem;
          width: 80px;
        }
        .des {
          margin-right: 1rem;
        }
        .el-button-ml {
          background-color: #be2316;
          color: #ffffff;
        }
      }
      /*复选组样式 start*/
      .el-checkbox-button {
        margin-right: 1rem;
      }
      .el-checkbox-button:first-child .el-checkbox-button__inner {
        border-radius: 0 !important;
      }
      .el-checkbox-button:last-child .el-checkbox-button__inner {
        border-radius: 0 !important;
      }
      .el-checkbox-button.is-checked .el-checkbox-button__inner {
        background-color: #be2316;
        border-color: #be2316;
        color: #ffffff;
        box-shadow: -1px 0 0 0 #be2316;
      }
      .el-checkbox-button__inner:hover {
        color: #be2316;
      }
      .el-checkbox-button .el-checkbox-button__inner {
        border: none !important;
      }
      .el-checkbox-button.is-checked:first-child .el-checkbox-button__inner {
        border-left-color: #be2316;
      }
      /*复选组样式 end*/
      /*单选组样式 start*/
      .el-radio-button {
        margin-right: 1rem;
      }
      .el-radio-button:first-child .el-radio-button__inner {
        border-radius: 0 !important;
      }
      .el-radio-button:last-child .el-radio-button__inner {
        border-radius: 0 !important;
      }
      .el-radio-button__orig-radio:checked + .el-radio-button__inner {
        background-color: #be2316;
        border-color: #be2316;
        color: #ffffff;
        box-shadow: -1px 0 0 0 #be2316;
      }
      .el-radio-button__inner:hover {
        color: #be2316;
      }
      .el-radio-button .el-radio-button__inner {
        border: none !important;
      }
      .el-radio-button.is-checked:first-child .el-radio-button__inner {
        border-left-color: #be2316;
      }
      /*单选组样式 end*/
      .transport-data {
        display: flex;
        .el-input {
          margin-right: 1rem;
        }
        .des {
          margin-right: 1rem;
        }
      }
      .form-item {
        margin-right: 0;
        .form-item-btn {
          background: #be2316;
          border: none;
          i {
            font-size: 14px;
            padding-right: 10px;
          }
        }
      }
    }
  }
  .content {
    position: relative;
    width: 1200px;
    margin: 0 auto;
    margin-bottom: 50px;
    .content-img {
      width: 1200px;
    }
    .content-shoucang-tc {
      position: absolute;
      top: 50%;
      left: 50%;
      margin-left: -85px;
      margin-top: -35px;
    }
    .content-baojia {
      position: absolute;
      width: 50px;
      height: 100%;
      right: 0;
      top: 0;
    }
    .content-shoucang {
      position: absolute;
      width: 50px;
      height: 100%;
      right: 50px;
      top: 0;
    }
  }
  /*表格相关*/
  .table-wrap {
    width: 1200px;
    margin: 0 auto;
  }
}

.invitation-data {
  .invitation-form {
    .condition-group {
      margin-top: 0.5rem;
      padding-left: 8px;
    }
  }
  .invitation-data-header {
    color: $main-color;
    font-weight: bold;
    background-color: #ffffff;
    height: 45px;
    margin-bottom: 1rem;
    ul {
      display: flex;
      flex-wrap: nowrap;
      height: 100%;
      width: calc(100% - 16px);
      padding: 8px 8px;
      box-sizing: content-box;
      li {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-size: 15px;
        min-width: 50px;
        height: 100%;
        line-height: 29px;
        padding: 5px 0.4%;
        text-align: center;
        &:nth-child(1) {
          flex-basis: 16%;
        }
        &:nth-child(2) {
          flex-basis: 16%;
        }
        &:nth-child(3) {
          flex-basis: 16%;
        }
        &:nth-child(4) {
          flex-basis: 13.5%;
        }
        &:nth-child(5) {
          flex-basis: 13.5%;
        }
        &:nth-child(6) {
          flex-basis: 25%;
          padding: 0;
        }
      }
    }
  }
  .invitation-data-body {
    position: relative;
    .no-data-info {
      background-color: #fff;
      width: 100%;
      text-align: center;
      margin-top: 8px;
      height: 48px;
      line-height: 48px;
      font-size: 15px;
    }
    .data-item {
      margin: 8px 0px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      border: 1px solid #ebeef5;
      position: relative;
      ul {
        display: flex;
        flex-wrap: nowrap;
        height: 56px;
        width: calc(100% - 16px);
        padding: 8px 8px;
        position: relative;
        background-color: white;
        li {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          font-size: 15px;
          min-width: 50px;
          height: 100%;
          line-height: 55px;
          padding: 5px 0.4%;
          text-align: center;
          &:nth-child(1) {
            flex-basis: 16%;
          }
          &:nth-child(2) {
            flex-basis: 16%;
          }
          &:nth-child(3) {
            flex-basis: 16%;
          }
          &:nth-child(4) {
            flex-basis: 13.5%;
          }
          &:nth-child(5) {
            flex-basis: 13.5%;
          }
          &:nth-child(6) {
            flex-basis: 25%;
            overflow: initial;
            padding: 0;
            white-space: initial;
          }
          /deep/ .el-button.is-plain {
            background-color: white;
            color: #be2316;
            border-color: #be2316;
            padding: 7px 4px !important;
            width: 56px;
            span > i {
              transition: 1s all;
              transform: rotateZ(90deg);
              &.expand {
                transform: rotateZ(-90deg);
              }
            }
          }
        }
      }
      /deep/ .goods-item-details {
        border: 1px solid #ebeef5;
        z-index: 0;
      }
    }
  }
  .invitation-data-pagination {
    width: calc(100% - 32px);
    margin-top: 24px;
    padding: 16px 0px;
    background-color: white;
  }
}
</style>

